import React from "react";

export const EditorContext = React.createContext({
  addNewPage: () => {},
  areFunctionalitiesLocked: () => {},
  canvasBackground: null,
  clearSelectItems: () => {},
  context: {
    isInTextEditMode: false,
    isTimelineVisible: false,
    playbackTime: 0
  },
  currentPageId: null,
  designData: null,
  elementPreviews: {},
  handleScroll: () => {},
  htmlElements: {},
  isDragging: false,
  isDraggingElementRef: { current: false },
  isGuideDragging: false,
  isResizing: false,
  isCropping: false,
  isMobile: false,
  isShowingDielineGuides: true,
  isShowingRulersAndGuides: false,
  moveSelection: () => {},
  duplicateSelection: () => {},
  onElementPreview: () => {},
  openMobileImagesPanel: () => {},
  selectedItems: [],
  sidePanel: { width: 0 },
  snapToCorners: true,
  toggleDielineGuides: () => {},
  zoom: 1,
  toggleTimeline: () => {},
  isTimelineVisible: false,
  timelineHeight: null,
  isDesignPlaybackMode: false,
  fitToPage: () => {},
  fitToSelection: () => {}
});

export default EditorContext;
